export const setSelectedStoreDetails = (data) => {
  return {
    type: "SET_STORE_DETAILS",
    payload: {
      data,
    },
  };
};

export const setModuleIds = (moduleIds) => {
  return {
    type: "SET_MODULE_IDS",
    payload: {
      moduleIds,
    },
  };
};
